// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const API_URI = process.env.REACT_APP_API_URL!

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const APP_URL = process.env.REACT_APP_APP_URL!

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const DATADOG_APPLICATION_ID = process.env.REACT_APP_DATADOG_APPLICATION_ID!

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const DATADOG_APPLICATION_NAME = process.env.REACT_APP_DATADOG_APPLICATION_NAME!

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const DATADOG_CLIENT_TOKEN = process.env.REACT_APP_DATADOG_CLIENT_TOKEN!

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const DATADOG_ENV = process.env.REACT_APP_DATADOG_ENV!

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const DATADOG_SITE = process.env.REACT_APP_DATADOG_SITE!

export const LANDING_URI = "https://www.heropay.eu"

export const CHECKOUT_COM_PUBLIC_KEY = process.env.REACT_APP_CHECKOUT_COM_PUBLIC_KEY || "unknown"
